








import { Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import SearchUserDropdown from './sysComponents/search-user-dropdown.vue';
import TemplateMixin from '../TemplateMixin.vue';

/**
 * 用户搜索框
 *
 * @author liyuyao
 * @date 04/22/2019
 */
@Component({
    components: {
        SearchUserDropdown
    }
})
export default class ComponentReporter extends TemplateMixin {
    @Prop({ default: '' })
    reporter: string;

    @State(state => state.cti.userInfo)
    userDisplayInfo: CommonTypes.userDisplayItem;

    dropdownVisible: boolean = false;

    userChange(username) {
        this.dropdownVisible = false;
        this.$emit('change', username);
    }
}
